<template>
  <div
    v-if="show"
    class="Square"
    :class="{ 'pointer-events-none': loading }"
    v-bc-uploader="{
      name: 'FolderGridItemUploadFiles',
      onFileUploadDone: fileUploadDone,
      onAllFilesUploadDone: allFilesUploadDone
    }"
  >
    <div class="Square__Pic cursor-pointer">
      <div>
        <div
          class="Square__Inicials !bg-transparent border border-bc-blue rounded-md text-bc-blue"
        >
          <div class="flex flex-col items-center">
            <aw-icon
              v-if="!loading"
              icon="upload"
              class="w-6 h-6 md:w-12 md:h-12 leading-tight text-bc-blue "
            />
            <aw-icon
              v-else
              icon="loading"
              class="animate-spin w-6 h-6 md:w-12 md:h-12 leading-tight text-bc-blue"
            />
            <div class="text-sm text-bc-blue text-center hidden md:block">
              {{ $t('Click or drop files anywhere to start upload') }}
            </div>
            <div class="text-sm text-bc-blue text-center md:hidden">
              {{ $t('Upload files') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AddDocument from '@/frontapp/mixins/AddDocument'
import { mapStores } from 'pinia'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import { updateGlobalUploader } from '../../globalUploader'

export default {
  mixins: [AddDocument],
  computed: {
    show() {
      return this.bcFolderStore.current?.can_edit
    },
    ...mapStores(useBcFolderStore)
  },
  methods: {
    fileUploadDone(/*file*/) {
      // do nothing
    },
    allFilesUploadDone(files) {
      const fileIds = files.map((file) => file.id)
      // remove ext from file name
      const name = files[0].name.replace(/\.[^/.]+$/, '')
      this.addDocument(name, fileIds)
    }
  },
  mounted() {
    updateGlobalUploader({
      uploaderId: 'folder',
      onFileUploadDone: this.fileUploadDone,
      onAllFilesUploadDone: this.allFilesUploadDone,
      enabled: true,
    })
  },
  beforeUnmount() {
    updateGlobalUploader({
      enabled: false,
    })
  },
  watch: {
    show(val) {
      let config

      if (val) {
        config = {
          uploaderId: 'folder',
          onFileUploadDone: this.fileUploadDone,
          onAllFilesUploadDone: this.allFilesUploadDone,
          enabled: val,
        }
      } else {
        config = {
          enabled: val,
        }
      }

      updateGlobalUploader(config)
    }
  }
}
</script>
